import TabbedStaticCarousel, { TabbedStaticCarouselProps } from '@/components/_rebrand/TabbedStaticCarousel';
import Image from 'next/image';

const displayProps = {
  title: undefined,
  description: null,
  slides: [],
  hideLogoBar: true,
  showHeader: true,
  isOnDark: false,
  formattingOptions: {
    paddingTop: "none",
    paddingBottom: "none",
  },
} as TabbedStaticCarouselProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

interface FeatureFromCraft {
  tabName: string;
  image: AssetImageFromCraft;
  icon: AssetImageFromCraft;
}

const formFeatures = (items: FeatureFromCraft[]): TabbedStaticCarouselProps["slides"] => {
  return items.map((feature) => {
    const originalWidth = feature.image[0].width;
    const originalHeight = feature.image[0].height;

    const targetWidth = 1200;
    const aspectRatio = originalHeight / originalWidth;
    const scaledHeight = Math.round(targetWidth * aspectRatio);

    return {
      image: (
        <Image
          src={feature.image[0].url}
          width={targetWidth}
          height={scaledHeight}
          alt={feature.image[0].title}
          loading="eager"
          className='w-full h-auto'
        />
      ),
      icon: (
        <Image
          src={feature.icon[0].url}
          width={feature.icon[0].width}
          height={feature.icon[0].height}
          className='w-2 h-auto'
          alt={feature.icon[0].title}
          loading="eager"
        />
      ),
      title: feature.tabName,
      description: "",
    };
  });
};

const setDynamicDisplayPropAttributes = (entry: any) => {
  displayProps.title = entry.header;
  displayProps.slides = formFeatures(entry.tabs);
}

const TabbedFeatures = ({ entry }) => {
  if (entry.__typename != 'comparisonModules_tabbedFeatures_BlockType') {
    return null;
  }
  setDynamicDisplayPropAttributes(entry);

  return (
    <TabbedStaticCarousel {...displayProps} />
  );
};

export default TabbedFeatures;
